import { Component, Input, Output, EventEmitter, inject } from '@angular/core';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { RightBridgeApiService } from '../../../services/right-bridge-api.service';
import { MatSelectModule } from '@angular/material/select';
import { MatRadioModule } from '@angular/material/radio';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';

@Component({
  selector: 'app-patch-profile',
  templateUrl: './patch-profile.component.html',
  styleUrls: ['../toolbox.component.scss'],
  imports: [
    MatSelectModule,
    MatRadioModule,
    FormsModule,
    MatButtonModule,
    MatInputModule,
  ],
})
export class PatchProfileComponent {
  private rbs = inject(RightBridgeApiService);

  @Output() toggleLoading = new EventEmitter();
  @Input() applications;

  patchProfile = {
    app: null,
    id: null,
    data: null,
    evaluate: false,
    returnProfile: false,
    status: null,
    statusClass: null,
  };

  saveProfilePatch() {
    this.toggleLoading.emit();
    this.rbs.setApp(this.patchProfile.app);
    this.rbs
      .saveProfile(
        this.patchProfile.id,
        this.patchProfile.data,
        this.patchProfile.evaluate,
        this.patchProfile.returnProfile
      )
      .subscribe({
        next: () => {
          this.toggleLoading.emit();
        },
        error: catchError(err => {
          this.toggleLoading.emit();
          this.patchProfile.status = err;
          this.patchProfile.statusClass = 'failure';
          return throwError(() => err.error || 'Server error');
        }),
      });
  }
}
